Monitoring.Dashboard ||= {}

class Monitoring.Dashboard.SocialUserExportableFieldsView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_user_exportable_fields']
  anotherTemplate: JST['backbone/templates/monitoring/custom_exportable_fields']
  events:
    'click .export-confirm' : 'onClickExport'
    'click .exportable-fields-option' : 'toggleExportableFieldsOption'

  initialize: (@exportable_fields_hash = {}, @fields_to_export_count) ->

  render: =>
    @$el.html(@template({fields: @exportable_fields_hash, count: @fields_to_export_count }))
    @

  toggleExportableFieldsOption: ()=>
    if @$( ".exportable-fields-list:first" ).is( ":hidden" )
      @$('.caret-hide-unhide').removeClass("fa fa-caret-down")
      @$('.caret-hide-unhide').addClass("fa fa-caret-up")
      @$('.exportable-fields-list').slideDown( "fast" )
    else
      @$('.caret-hide-unhide').removeClass("fa fa-caret-up")
      @$('.caret-hide-unhide').addClass("fa fa-caret-down")
      @$('.exportable-fields-list').slideUp( "fast" )

  isSelected: (field_name)=>
    @$('#'+field_name)[0].checked

  addSection: (fields, section_title, default2) =>
    p1 = @first_part(fields)
    p2 = @last_part(fields)
    template = @anotherTemplate({title: section_title, p1: p1, p2: p2, default2: default2})
    section = $('<div></div>')
    section.html(template)
    @$('.first-exportable-fields-list').append(section)

  first_part:(user_profile_attributes)=>
    keys = Object.keys(user_profile_attributes)
    m = Math.round (keys.length/2)
    p1 = keys.slice(0, m)
    h = {}
    _.map(p1, (key) =>
        h[key] = (user_profile_attributes[key])
    )
    h

  last_part:(user_profile_attributes) =>
    keys = Object.keys(user_profile_attributes)
    m = Math.round (keys.length/2)
    p2 = keys.slice(m , keys.length)
    h = {}
    _.map(p2, (key) =>
        h[key] = (user_profile_attributes[key])
    )
    h

  onClickExport: (event) =>
    event.stopPropagation()
    @trigger('on-export-confirm')
    swal
      title: I18n.t 'customer.dashboard.modal_export_fields.export_started_title'
      text: I18n.t 'customer.dashboard.modal_export_fields.export_started_message'
      type: 'info'

  showModal: =>
    @$('#exportable-fields-modal').modal()

  _selectedFromHash: (selectable_hash) =>
    h = {}
    _.map(selectable_hash, (value, key) =>
      if @isSelected(key)
        h[key] = value
    )
    h